<div
  role="option"
  class="pg-drop-down-item grit-drop-down-item"
  *ngFor="let child of dropDownItems"
  [innerHTML]="formatDisplayText(child.displayText)"
  (click)="handleItemClicked(child)"
  [attr.id]="child.id"
  #dropDownItem
></div>
